import classNames from 'classnames';
import { HeaderOPC } from 'components/Layout/Header';
import { ProductList } from 'components/Products';
import React from 'react';

import OPCImg from 'assets/img/opc_solo.png';
import getTranslate from '../../customHooks/getTranslate';
import styles from './styles.module.scss';

const Welcome: React.FC = () => (
  <div
    className={classNames(
      'flex-fill d-flex flex-column bg-color-lt',
      styles.background,
    )}
  >
    <HeaderOPC />
    <div className="container flex-fill d-flex w-50 ">
      <main
        className={classNames(
          'd-flex flex-column justify-content-center',
          styles.wrapper,
        )}
      >
        <h2 className="mb-5">
          {/* {i18next.t('welcomeToOpc')}
          ,
          {' '}
          <br /> */}
          {getTranslate('accessOneOfOurBelowProducts')}
          :
        </h2>

        <ProductList />

        <div className="d-flex align-items-center justify-content-center mt-5">
          <img src={OPCImg} alt="OPC" />
          <p className="font-size-lg mb-0">
            by
            {' '}
            <span className="font-size-xl ms-2">EAIPure</span>
          </p>
        </div>
      </main>
    </div>
  </div>
);

export default Welcome;
